import React from "react";
import "./Carousel.css";

import Dhothis from "../image/DrapesDothis.jpeg";
import Advaita from "../image/Advaita.jpeg";
import vufinancial from "../image/vufinancialservice.jpeg";
import Ganesh from "../image/GaneshImage.jpeg";
import Pitchblack from "../image/pitchblack.jpeg";
import coremax from "../image/coremax.jpeg";
import Shruve from "../image/suve.jpeg";
import suveweding from "../image/suvewedding.jpeg";
import cakefather from "../image/cakefather.jpeg";
import ish from "../image/ishevent.jpeg";
import Dharson from "../image/Dharsan.jpeg";
import Survephoto from "../image/photographysurvy.jpeg";
import ThaiFoundation from "../image/Thai Foundation.png";
import neram from "../image/neram sarees.png";
import uklogo from "../image/UK LOGO NEW 12.PNG";
/* 🔹 NEW LOGO IMPORTS */
import RahulAtelier from "../image/raahulsatelier.jpg";
import RahulFlatDevelopers from "../image/rahulflatdevelopers.jpg";
import anikaVIlla from "../image/anikalogo.png";

import { Card } from "antd";

const Carousel = () => {
  const cardsData = [
    { image: Ganesh, text: "Sri Ganesh Enterprises" },
    { image: suveweding, text: "Sri Ganesh Enterprises" },
    { image: Survephoto, text: "Sri Ganesh Enterprises" },
    { image: vufinancial, text: "V For U Financial Services" },
    { image: cakefather, text: "V For U Financial Services" },
    { image: ish, text: "V For U Financial Services" },
    { image: Shruve, text: "Sri Ganesh Enterprises" },
    { image: Pitchblack, text: "Sri Ganesh Enterprises" },
    { image: coremax, text: "CoreMax Enterprises" },
    // { image: Dhothis, text: "Drapes & Dhotis" },
    { image: Advaita, text: "Advaita Yogashala" },
    { image: Dharson, text: "Advaita Yogashala" },
    { image: RahulAtelier, text: "Rahul Atelier" },
    { image: RahulFlatDevelopers, text: "Rahul Flat Developers" },
    { image: uklogo, text: "Uk-logo" },
    { image: ThaiFoundation, text: "ThaiFoundation" },
    { image: neram, text: "neram" },
    { image: anikaVIlla, text: "anikaVIlla" },
  ];

  return (
    <div className="container">
      <div className="row mt-5">
        <h2 className="text-center testimonials-text">
          Real stories, real results. See our clients' success testimonials!
        </h2>
      </div>

      <div className="container-fluid py-3 scroll-container">
        <div className="col-lg-12">
          <div className="d-flex scroll-content">
            {[...cardsData, ...cardsData].map((item, index) => (
              <div key={index} className="card-wrapper">
                <Card>
                  <img
                    src={item.image}
                    alt={item.text}
                    style={{
                      height: "140px",
                      width: "200px",
                      objectFit: "contain",
                      borderRadius: "15px",
                    }}
                  />
                </Card>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
